export default {
  PROBE: "probe",
  COUNTER: "counter"
};
